import Nav from 'react-bootstrap/Nav';
import styles from './categoryNav.module.scss';
import { useTranslation } from 'next-i18next';
import translationFallback from '@/utilites/translations/translationFallback';
import uiItems from '@/constants/ui-items/index.constants';
import event from '@/utilites/gTag';
import { useRouter } from 'next/router';
import DefaultButton from '../common/default/DefaultButton';

const CategoryNav = ({ userId }: { userId: string | null }) => {
  const { push, locale } = useRouter();
  const { t: tCommon } = useTranslation('common');

  const handleNavClick = (href: string, tKey: string) => {
    if (tKey === 'whisky' || tKey === 'rum' || tKey === 'gin') {
      event(
        tKey === 'whisky'
          ? 'whisky_category_button_click'
          : tKey === 'rum'
            ? 'rum_category_button_click'
            : 'gin_category_button_click',
        {
          event_category: 'interaction',
          device: 'Website',
        },
        { userId: userId, lang: locale }
      );
    }

    push(href);
  };

  return (
    <Nav
      className={`${styles.hover} position-relative z-index-1 max-nine:tw-m-auto max-nine:!tw-mb-4 max-nine:tw-flex max-nine:tw-gap-4 max-nine:!tw-px-4`}
    >
      {uiItems.categoryNavItems.map((item, index) => (
        <Nav.Item key={index} className="px-lg-5">
          <Nav.Link
            as={DefaultButton}
            className="s-sub-title text-decoration-none tw-rounded-full !tw-font-bold !tw-text-text tw-transition-colors tw-duration-300 hover:tw-bg-main hover:!tw-text-white focus:tw-bg-main focus:!tw-text-white active:tw-bg-main active:!tw-text-white max-nine:!tw-p-0 max-nine:!tw-font-semibold"
            onClick={() => handleNavClick(item.href, item.tKey)}
          >
            {translationFallback(item.tKey, tCommon(item.tKey), item.tFallback)}
          </Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
};

export default CategoryNav;
